module.exports = __webpack_public_path__ + "img/egg1.09d378d4.gif";